var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"pagina"}},[_c('Banner',{attrs:{"nomePagina":_vm.pagina.nome}}),_c('Menu',{attrs:{"menu":_vm.menu}}),(_vm.pagina.secoes)?_c('Conteudo',{attrs:{"conteudo":_vm.pagina.secoes[0].conteudo}}):_vm._e(),_c('BlogFael')],1)}
var staticRenderFns = []

export { render, staticRenderFns }